import { Button, Icon, Styles } from "@/shared/coralreef";
import {
  faExclamationTriangle,
  faRefresh,
} from "@fortawesome/free-solid-svg-icons";
import { signOut } from "aws-amplify/auth";
import { important, percent, px, rem, viewHeight } from "csx";
import { Content, Horizontal, Stretch, Vertical } from "gls";
import { useTranslation } from "react-i18next";
import { style } from "typestyle";

async function clearAuthAndReload() {
  try {
    await signOut();
  } catch {
    /* ignore */
  }
  try {
    localStorage.removeItem("id_token");
    localStorage.removeItem("token");
    localStorage.removeItem("refresh_token");
    for (let i = localStorage.length - 1; i >= 0; i--) {
      const k = localStorage.key(i);
      if (
        k &&
        (k.startsWith("CognitoIdentityServiceProvider.") ||
          k.startsWith("aws-amplify-"))
      ) {
        localStorage.removeItem(k);
      }
    }
    sessionStorage.clear();
  } catch {
    /* ignore */
  }
  window.location.assign("/login");
}

export const ErrorPage = () => {
  const { t } = useTranslation();

  return (
    <Vertical
      width={percent(100)}
      padding={[viewHeight(20), 0, 0, 0]}
      horizontalAlign="center"
      className={style({
        color: Styles.Colours.textLight,
      })}
    >
      <Icon
        icon={faExclamationTriangle}
        className={style({
          width: important(rem(8)),
          height: important(rem(8)),
        })}
      />
      <h1>{t("Error")}</h1>
      <Vertical
        spacing={0}
        horizontalAlign="center"
        className={style({
          color: Styles.Colours.textLight,
        })}
      >
        <Content>{t("Something has gone wrong")}</Content>
        <Content>{t("Please contact your administrator")}</Content>
        <Horizontal width={percent(100)} verticalAlign="center">
          <Divider />
          <Content
            className={style({
              color: Styles.Colours.textDisabled,
            })}
          >
            {t("or")}
          </Content>
          <Divider />
        </Horizontal>
        <Button
          content={t("Refresh")}
          icon={faRefresh}
          appearance="hollow"
          onClick={() => {
            void clearAuthAndReload();
          }}
        />
      </Vertical>
    </Vertical>
  );
};

const Divider = () => (
  <Stretch
    className={style({
      height: px(1),
      background: Styles.Colours.textDisabled,
    })}
  />
);
